import React, { useState } from "react";
import Img from '../../common/Img';
import BetSelector from '../../common/BetSelector';
import Odd from '../../common/Odd';
import Modal from '../../common/Modal';
import EventStats from '../../common/EventStats';
import { openModal } from '../../common/ModalContainer';
import Link from '../../router/Link';
import { useLiveData } from '../../live/LiveDataProvider';
import { classIf, iconCategoryCssClass } from '../../data/utils';
import { getEventUrl } from '../../prematch/Prematch';
import { getFullScores } from '../../live/scores/scores';
import FavoriteTournamentButton from '../../common/favorite-tournaments/FavoriteTournamentButton';
import OddSelector from '../../common/OddSelector';
import ErrorMessage from '../../common/ErrorMessage';
import HandicapDesc from '../../common/HandicapDesc';
import BettingClosedMessageInline from '../../common/BettingClosedMessageInline';
import { getLabel } from '../../InitData';
import { groupScores, isOddSelector } from "../../prematch/Tournament";
import AdditionalDataMessage from "../../common/additional-data/AdditionalDataMessage";

export default function Tournament(props) {
    const liveData = useLiveData();
    const data = props.data;
    let [selected, setSelected] = useState(null);
    
    
    try {
        const bets = data.events[0].bets;
        if (selected == null) {
            selected = bets.length === 1 ? [bets[0]] : [bets[0], bets[1]];
        }
        function changeBet(index, id) {
            const newSelections = Array.from(selected);
            newSelections[index] = id;
            setSelected(newSelections);
        }
        const ids = new Set(selected.map(b => b.id));
    
        const sport = liveData.sportById[data.sportRef];
        const category = sport.categoryById[data.categoryRef];
        const categoryIcon = iconCategoryCssClass(sport.id, category.id, category.categoryIcon);
        const [periods, scoresByEvent] = groupScores(data.events);
    
        return (
            <>
                <div className="c_29">
                    <div className="c_29_1">
                        <span className={"c_29_1_1 " + categoryIcon}></span>
                        <span className="c_29_1_2">{category.descrizione} - {data.descrizione || data.desc}</span>
                        <Img className="c_29_1_3" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" />
                    </div>
                    <AdditionalDataMessage className="c_29_2" message={data.additionalData} />
                    <FavoriteTournamentButton id={data.uniqueId} />
                </div>
                <div className="c_24">
                    <div className="c_24_1">
                        <div className="c_24_1_1">{sport.descrizione}</div>
                        <div className="c_24_1_2">
                            <div className="c_24_1_2_2">
                                {periods.map(p =>
                                    <div key={p} className="c_24_1_2_2_1">{p}</div>
                                )}
                            </div>
                        </div>
                        <div className="c_24_1_3">
                            <div className="c_26">
                                {selected.map((b, i) =>
                                    <BetSelector key={b.uniqueId}
                                                 bets={bets}
                                                 toFilter={ids}
                                                 selected={b}
                                                 changeBet={(id) => changeBet(i, id)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="c_24_2">
                        <div className="c_24_2_1">
                            <div className="c_26">
                                {selected.map(b =>
                                    <div key={b.uniqueId} className="c_27">
                                        {b.parametrica &&
                                            <div className="c_28">{b.handicapTableDesc}</div>
                                        }
                                        {!isOddSelector(b) && b.odds.map(o =>
                                            <div key={o.uniqueId} className="c_28">{o.descNoHandicap || o.desc}</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {data.events.map(e => {
                        const betsById = new Map();
                        e.bets.forEach(b => betsById.set(b.id, b));
                        const bets = selected.map(b => betsById.get(b.id));
                        const [, scoresTeam1, scoresTeam2] = getFullScores(periods, scoresByEvent.get(e.uniqueId), 'c_24_3_3_1_1', 'c_24_3_3_1_1');
                        const url = getEventUrl(e);
    
                        function handleClick(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            openModal(
                                <Modal title={'Stats'} type="big">
                                    <EventStats data={e} />
                                </Modal>
                            );
                        }
                        
                        return (
                            <Link href={url} key={e.uniqueId} className="c_24_3">
                                <div className="c_24_3_1">
                                    <span className="c_24_3_1_2">{e.score?.periodo}</span>
                                    <span className="c_24_3_1_2">{e.score?.currentMinute}</span>
                                </div>
                                <div className="c_24_3_2">
                                    <div className="c_24_3_2_1">
                                        <div className={"c_24_3_2_1_1" + classIf(e.score?.srv === 1, 'active')}></div>
                                        <span className="c_24_3_2_1_2" title={e.team1}>{e.team1}</span>
                                    </div>
                                    <div className="c_24_3_2_1">
                                        <div className={"c_24_3_2_1_1" + classIf(e.score?.srv === 2, 'active')}></div>
                                        <span className="c_24_3_2_1_2" title={e.team2}>{e.team2}</span>
                                    </div>
                                </div>
                                <div className="c_24_3_3">
                                    <span className="c_24_3_3_1">{scoresTeam1}</span>
                                    <span className="c_24_3_3_1">{scoresTeam2}</span>
                                </div>
                                <div className="c_24_3_4">
                                    <div className="c_26">
                                        {e.giocabilita === false ?
                                            <BettingClosedMessageInline />
                                            :
                                            (bets.map(b =>
                                                <div key={b.uniqueId} className="c_27">
                                                    {b.parametrica &&
                                                        <HandicapDesc desc={b.handicapDesc} />
                                                    }
                                                    {isOddSelector(b) ?
                                                        <OddSelector odds={b.odds} />
                                                        :
                                                        (b.odds.map(o =>
                                                            <Odd key={o.uniqueId} data={o} type={2} />
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className="c_24_3_5">
                                    <Img className="c_24_3_5_1" src="icon_stats.svg" height="16px" width="16px" onClick={handleClick} />
                                    <div className="c_24_3_5_2">
                                        <span className="c_24_3_5_2_1">+{e.plus}</span>
                                        <Img className="c_24_3_5_2_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" />
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </>
        );
    } catch (e) {
        console.error(e);
        return (
            <ErrorMessage text={getLabel('general.error')} />
        );
    }
}
